import type {
  AssetType,
  LifecycleState,
  RiskClassification,
} from "@/api";
import type { BadgeTone } from "@/components/ui/badge";

export const ASSET_TYPES: ReadonlyArray<AssetType> = [
  "prompt",
  "model",
  "agent",
  "workflow",
  "provider",
  "tool",
  "dataset",
];

export const ASSET_TYPE_LABEL: Record<AssetType, string> = {
  prompt: "Prompt",
  model: "Model",
  agent: "Agent",
  workflow: "Workflow",
  provider: "Provider",
  tool: "Tool",
  dataset: "Dataset",
};

export const LIFECYCLE_STATES: ReadonlyArray<LifecycleState> = [
  "draft",
  "review",
  "active",
  "deprecated",
  "retired",
];

export const LIFECYCLE_LABEL: Record<LifecycleState, string> = {
  draft: "Draft",
  review: "Review",
  active: "Aktif",
  deprecated: "Deprecated",
  retired: "Pensiun",
};

export const LIFECYCLE_TONE: Record<LifecycleState, BadgeTone> = {
  draft: "neutral",
  review: "info",
  active: "success",
  deprecated: "warning",
  retired: "neutral",
};

export const RISK_CLASSIFICATIONS: ReadonlyArray<RiskClassification> = [
  "low",
  "medium",
  "high",
  "critical",
];

export const RISK_LABEL: Record<RiskClassification, string> = {
  low: "Rendah",
  medium: "Sedang",
  high: "Tinggi",
  critical: "Kritikal",
};

// Ocean Blue palette only — no rogue colours. low/medium use the
// neutral end of the spectrum, high/critical pull from the
// warning / danger semantic tones.
export const RISK_TONE: Record<RiskClassification, BadgeTone> = {
  low: "neutral",
  medium: "ocean",
  high: "warning",
  critical: "danger",
};
